import { Code, ConnectError } from "@bufbuild/connect";
import {
  PortalEventService,
  PortalEventServiceGetTicketsBonusMediaRequest,
} from "@spwn-portal/grpc";
import useSWRMutation from "swr/mutation";
import { useConnectClient } from "utility/connectWeb";

import type { PortalEventServiceGetTicketsBonusMediaResponse } from "@spwn-portal/grpc";

export type EventTicketBonusMedia = {
  eventId: string;
  ticketId: string;
  // アップロードされたファイルのID
  mediaId: string;
  // アップロードされたファイルの名前
  filename: string;
  // 特典名
  bonusName: string;
  // ダウンロード開始日時
  releaseAt?: Date;
  // ダウンロード期限
  expiredAt?: Date;
  // ダウンロードURL
  urlForDownload?: string;
  groupName?: string;
};

const convertBigIntToDate = (timestamp: bigint | undefined) => {
  if (timestamp === undefined) return undefined;
  return new Date(Number(timestamp));
};

const mapResponseToBonusMediaList = (
  response: PortalEventServiceGetTicketsBonusMediaResponse,
  eventId: string
): EventTicketBonusMedia[] => {
  return response.ticketBonusMedia.map<EventTicketBonusMedia>((bonus) => ({
    eventId,
    ticketId: bonus.ticketId,
    mediaId: bonus.mediaId,
    filename: bonus.filename,
    bonusName: bonus.bonusName,
    releaseAt: convertBigIntToDate(bonus.releaseAt),
    expiredAt: convertBigIntToDate(bonus.expiredAt),
    urlForDownload: bonus.urlForDownload,
    groupName: bonus.groupName,
  }));
};

export const useEventTicketsBonusMediaLazy = (
  eventId: string,
  ticketIds: string[],
  orderId?: string
) => {
  const connectClient = useConnectClient(PortalEventService);

  return useSWRMutation(
    ["getTicketsBonusMedia", eventId, ticketIds, orderId],
    async () => {
      if (ticketIds.length === 0) {
        console.warn("チケットが存在しないイベントです");
        return [];
      }

      try {
        const response = await connectClient.getTicketsBonusMedia(
          new PortalEventServiceGetTicketsBonusMediaRequest({
            eventId,
            ticketIds,
            orderId,
          })
        );
        return mapResponseToBonusMediaList(response, eventId);
      } catch (e) {
        if (e instanceof ConnectError && e.code === Code.NotFound) {
          // 共有チケットだとエラーになるはずなのでここで無視する
          // ※現状エラーにはなっていない
          return [];
        }
        throw e;
      }
    }
  );
};
